import {createModelSchema, primitive, identifier,} from 'serializr';

export class Opp {
    id!: number;
    krs!: string;
    nazwa!: string;
    ulica_nr!: string;
    kod_pocztowy!: string;
    miejscowosc!: string;
    telefon_stacjonarny_1!: string;
    telefon_stacjonarny_2!: string;
    telefon_komorkowy!: string;
    email!: string;
    www!: string;
    data_dodania!: Date;
    blokada!: boolean;
}

createModelSchema(Opp, {
    id: identifier(),
    krs: primitive(),
    nazwa: primitive(),
    ulica_nr: primitive(),
    kod_pocztowy: primitive(),
    miejscowosc: primitive(),
    telefon_stacjonarny_1: primitive(),
    telefon_stacjonarny_2: primitive(),
    telefon_komorkowy: primitive(),
    email: primitive(),
    www: primitive(),
    data_dodania: primitive(),
    blokada: primitive(),
});
